// extracted by mini-css-extract-plugin
export var productImage = "_o6-0";